/*eslint-disable */
import moment from 'moment';
export default {
  name: 'deleted-meetings-list',
  components: {
  },
  props: [],
  data () {
    return {
      deletedMeetingData:null,
      deletedMeetingDataResult:[]
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('getDeletedMeetingListAction').then((res) => {
      this.deletedMeetingData = res.data.data
      this.deletedMeetingDataResult = [].concat(this.deletedMeetingData.results)
    })
  },
  methods: {
    statusCheckOfMeeting(startTime){
      var startTime2 = moment(startTime).local().format();
      var curentDateUTC = moment().local().format();
      if (startTime2 > curentDateUTC){
        return true;
      }else{   
        return false;
      }
    },
  },
}